import AXIOS from "./axios";

export class DoctorDocument {
  static fetchAll() {
    return AXIOS.get("/doctor_documents");
  }

  static create(doctorDocument) {
    return AXIOS.post("/doctor_documents", { doctor_document: doctorDocument });
  }

  static show(id) {
    return AXIOS.get(`/doctor_documents/${id}`);
  }

  static update(id, doctorDocument) {
    return AXIOS.put(`/doctor_documents/${id}`, {
      doctor_document: doctorDocument
    });
  }

  static destroy(id) {
    return AXIOS.delete(`/doctor_documents/${id}`);
  }
}
